import type {FC} from 'react';
import clsx from 'clsx';

import {GridCarousel} from '@/components/content-blocks/link-list-selection/grid-carousel';
import {GridDetails} from '@/components/content-blocks/link-list-selection/grid-details';
import {GridImages} from '@/components/content-blocks/link-list-selection/grid-images';
import {Container} from '@/modules/foundation/components/container';
import {Heading} from '@/modules/foundation/components/typography/heading';

import type {LinkListSelectionFragment} from './query';

interface Props {
	data: LinkListSelectionFragment;
}

export const LinkListSelection: FC<Props> = ({data}) => {
	const {layout, title, linkItems, type = 'gridDetails'} = data ?? {};

	return (
		<div className={clsx('overflow-x-hidden')}>
			<Container spacingBottom={layout?.spacingBottom} spacingTop={layout?.spacingTop}>
				<div>
					{title && (
						<Heading
							level={2}
							spacing
							className={clsx('text-gronn-industri', 'text-3xl!')}
						>
							{title}
						</Heading>
					)}
					{type === 'gridCarousel' && (
						<GridCarousel linkItems={linkItems} headingLevel={title ? 3 : 2} />
					)}
					{type === 'gridDetails' && (
						<GridDetails linkItems={linkItems} headingLevel={title ? 3 : 2} />
					)}
					{type === 'gridImages' && (
						<GridImages linkItems={linkItems} headingLevel={title ? 3 : 2} />
					)}
				</div>
			</Container>
		</div>
	);
};
